import { render, staticRenderFns } from "./LetterEdit.vue?vue&type=template&id=27356bb2&scoped=true&"
import script from "./LetterEdit.vue?vue&type=script&lang=js&"
export * from "./LetterEdit.vue?vue&type=script&lang=js&"
import style0 from "./LetterEdit.vue?vue&type=style&index=0&id=27356bb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27356bb2",
  null
  
)

export default component.exports